import styled, { css } from "styled-components";

interface IButtonProps {
  buttonSize: string;
  buttonStyle: string;
}

const ThemeButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  height: 48px;
  transition: 155ms;
  color: var(--color-gray-0);
  cursor: pointer;

  ${(props: IButtonProps) => {
    switch (props.buttonSize) {
      case "medium":
        return css`
          height: 40px;
          padding: 0px 16px;
          font-size: 12px;
        `;
      case "small":
        return css`
          height: 32px;
          padding: 0px 16px;
          width: 55px;
          font-size: 12px;
        `;
      default:
        return css`
          height: 48px;
          width: 100%;
        `;
    }
  }}

  ${(props: IButtonProps) => {
    switch (props.buttonStyle) {
      case "disable":
        return css`
          background-color: var(--color-gray-1);
          border: 1.2182px solid var(--color-gray-1);

          &:hover {
            background-color: var(--color-gray-2);
            border-color: var(--color-gray-2);
          }
        `;
      case "primary-disable":
        return css`
          background-color: var(--color-primary--negative);
          border: 1.2182px solid var(--color-primary--negative);

          &:hover {
            background-color: var(--color-primary--focus);
            border-color: var(--color-primary--focus);
          }
        `;
      case "medium-style":
        return css`
          background-color: var(--color-gray-3);
          border: none;

          &:hover {
            background-color: var(--color-gray-2);
            border-color: var(--color-gray-2);
          }
        `;
      default:
        return css`
          background-color: var(--color-primary);
          border: 1.2182px solid var(--color-primary);

          &:hover {
            background-color: var(--color-primary--focus);
            border-color: var(--color-primary--focus);
          }
        `;
    }
  }}
`;

export default ThemeButton;
